import { render, staticRenderFns } from "./TruncatedList.vue?vue&type=template&id=06a58698&scoped=true&lang=pug&"
import script from "./TruncatedList.vue?vue&type=script&lang=js&"
export * from "./TruncatedList.vue?vue&type=script&lang=js&"
import style0 from "./TruncatedList.vue?vue&type=style&index=0&id=06a58698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a58698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VAlert,VSimpleTable,VSlider})
